// src/components/SideMenu/SideMenu.js
import React, { useEffect, useState } from 'react';

import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import MenuSeparator from './MenuSeparator';

import { removeItem } from 'utils/localstorage'
import { LOCALSTORAGE_KEY } from 'utils/constants'
import Logo from 'assets/iso-logo.png'
import './SideMenu.css'

function SideMenu(props) {
	const { location, history, setLoggedIn, menuExpanded, setMenuExpanded } = props

	// Estado local para el elemento seleccionado
	const [selected, setSelected] = useState(() => {
		let path = location.pathname.substring(1)
		if (path === 'login' || path === '') {
			return 'inicio'
		}
		return path
	})

	// Estado para controlar que submenus estan expandidos
	const [expanded, setExpanded] = useState(() => {
		// Expansion inicial basada en la ruta
		const path = location.pathname.substring(1)
		return {
			profesionales: path.startsWith('profesionales/'),
			solicitudes: path.startsWith('solicitudes/')
		}
	})

	// Ref para trackear la seccion anterior
	const prevSectionRef = React.useRef(() => {
		const path = location.pathname.substring(1)
		return path.split('/')[0]
	})

	// Actualizar el elemento seleccionado cuando cambia la ruta
	useEffect(() => {
		let path = location.pathname.substring(1)
		if (path === 'login' || path === '') {
			path = 'inicio'
		}
		setSelected(path)

		// Detectar si cambiamos de seccion base
		const currentSection = path.split('/')[0]
		const prevSection = prevSectionRef.current

		// Solo expandir si ENTRAMOS a una nueva seccion con submenus
		if (currentSection !== prevSection) {
			if (path.startsWith('profesionales/')) {
				setExpanded(prev => ({ ...prev, profesionales: true }))
			}
			if (path.startsWith('solicitudes/')) {
				setExpanded(prev => ({ ...prev, solicitudes: true }))
			}
		}

		prevSectionRef.current = currentSection
	}, [location.pathname])

	const onToggle = (isExpanded) => {
		setMenuExpanded(isExpanded)
	}

	const handleLogOut = () => {
		setLoggedIn(false);
		removeItem(LOCALSTORAGE_KEY);
	}

	// Manejar el toggle de submenus
	const handleToggleSubmenu = (menu) => {
		setExpanded(prev => ({
			...prev,
			[menu]: !prev[menu]
		}))
	}

	return (
		<SideNav
			expanded={menuExpanded}
			onToggle={onToggle}
			id="sidenav"
			onSelect={(selectedKey) => {
				// Si se hace clic en un menu con submenus, solo expandir/colapsar
				if (selectedKey === 'profesionales') {
					handleToggleSubmenu('profesionales')
					return
				}
				if (selectedKey === 'solicitudes') {
					handleToggleSubmenu('solicitudes')
					return
				}

				// Para otros elementos, navegar normalmente
				const to = '/' + selectedKey;
				if (location.pathname !== to) {
					history.push(to);
				}
			}}
		>
			<SideNav.Toggle />
			<div className="sidenavHeader">

			</div>
			<SideNav.Nav selected={selected}>
				<div className="sidenavLogo">
					<img src={Logo} alt="logo" />
				</div>
				<NavItem eventKey="inicio">
					<NavIcon>
						<i className="fa fa-fw fa-home" />
					</NavIcon>
					<NavText>
						Inicio
					</NavText>
				</NavItem>
				<NavItem
					eventKey="profesionales"
					expanded={expanded.profesionales}
				>
					<NavIcon>
						<i className="fa fa-person-dots-from-line" />
					</NavIcon>
					<NavText>
						Profesionales <div className="submenu-nav">
							{expanded.profesionales ?
								<i className="fa fa-caret-up"></i> :
								<i className="fa fa-caret-down"></i>
							}
						</div>
					</NavText>
					<NavItem eventKey="profesionales/pendientes">
						<NavText title="Pendientes">
							Pendientes
						</NavText>
					</NavItem>
					<NavItem eventKey="profesionales/activos">
						<NavText title="Activos">
							Activos
						</NavText>
					</NavItem>
				</NavItem>
				<NavItem eventKey="usuarios">
					<NavIcon>
						<i className="fa-solid fa-users"></i>
					</NavIcon>
					<NavText>
						Usuarios
					</NavText>
				</NavItem>
				<NavItem
					eventKey="solicitudes"
					expanded={expanded.solicitudes}
				>
					<NavIcon>
						<i className="fa-solid fa-clipboard-list" />
					</NavIcon>
					<NavText>
						Solicitudes <div className="submenu-nav">
							{expanded.solicitudes ?
								<i className="fa fa-caret-up"></i> :
								<i className="fa fa-caret-down"></i>
							}
						</div>
					</NavText>
					<NavItem eventKey="solicitudes/activas">
						<NavText>Activas</NavText>
					</NavItem>
					<NavItem eventKey="solicitudes/agendadas">
						<NavText>Agendadas</NavText>
					</NavItem>
					<NavItem eventKey="solicitudes/historial">
						<NavText>Historial</NavText>
					</NavItem>
				</NavItem>
				<MenuSeparator />
				<NavItem eventKey="qr">
					<NavIcon>
						<i className="fa-solid fa-barcode"></i>
					</NavIcon>
					<NavText>
						QR
					</NavText>
				</NavItem>
				{ /*
				<NavItem eventKey="actualizaciones">
					<NavIcon>
						<i className="fa fa-arrows-rotate" />
					</NavIcon>
					<NavText>
						Actualizaciones <div className="submenu-nav"><i className="fa fa-caret-down expand"></i> <i className="fa fa-caret-up collapse"></i></div>
					</NavText>
					<NavItem eventKey="actualizaciones/lista">
						<NavText title="Lista">
							Lista
						</NavText>
					</NavItem>
					<NavItem eventKey="actualizaciones/log">
						<NavText title="Log">
							Log
						</NavText>
					</NavItem>
				</NavItem>
				<NavItem eventKey="productosImagenes">
					<NavIcon>
						<i className="fa-regular fa-image"></i>
					</NavIcon>
					<NavText>
						Productos con imágenes
					</NavText>
				</NavItem>
				<NavItem eventKey="productosConEstado">
					<NavIcon>
						<i className="fa-solid fa-temperature-empty"></i>
					</NavIcon>
					<NavText>
						Productos con estado
					</NavText>
				</NavItem>
				*/ }
				<MenuSeparator />
				<NavItem eventKey="logout" onClick={handleLogOut}>
					<NavIcon>
						<i className="fa fa-fw fa-power-off" style={{ fontSize: '1.5em' }} />
					</NavIcon>
					<NavText style={{ paddingRight: 32 }} title="Cerrar">
						Cerrar
					</NavText>
				</NavItem>
			</SideNav.Nav>
		</SideNav>
	)
}

export default SideMenu